import React, { useState } from 'react';
import Campaign from './Campaign';
import CampaignForm from './CampaignForm';
import WelcomeNameContainer from '../LaunchComponent/WelcomeNameContainer';
import "./Home.css";
const CampaignHome = ({
  setFlag,
  typeOfUser
}) => {
  const [campaignMetaData, setCMD] = useState(null);
  const [l2, setL2] = useState("");
  return <div>
    <WelcomeNameContainer currentComp="campaign" l1={"Build Your Campaign"} l2={l2} />
    {campaignMetaData ? <div className="migrated-style-home-2b0570-1">
      <Campaign campaignMetaData={campaignMetaData} approvalView={false} setFlag={setFlag} />
    </div> : <CampaignForm setCMD={setCMD} setL2={setL2} typeOfUser={typeOfUser} />}
    </div>;
};
export default CampaignHome;
